import { gql } from '@apollo/client'

import { TaskFragment } from '../fragments'

export const MUTATION_CREATE_TASKS = gql`
  mutation createTasks($input: TasksCreateInput!) {
    createTasks(input: $input)
  }
`

export const MUTATION_UPDATE_TASK = gql`
  mutation updateTask($input: TaskUpdateInput!) {
    updateTask(input: $input) {
      ...TaskFragment
    }
  }
  ${TaskFragment}
`

export const MUTATION_UPDATE_TASK_STATUS = gql`
  mutation updateTaskStatus($input: TaskStatusUpdateInput!) {
    updateTaskStatus(input: $input) {
      ...TaskFragment
    }
  }
  ${TaskFragment}
`

export const MUTATION_UPDATE_TASK_PROGRESS = gql`
  mutation updateTaskProgress($input: TaskProgressUpdateInput!) {
    updateTaskProgress(input: $input) {
      ...TaskFragment
    }
  }
  ${TaskFragment}
`

export const MUTATION_UPDATE_TASKS = gql`
  mutation updateTasks($input: TasksUpdateInput!) {
    updateTasks(input: $input)
  }
`

export const MUTATION_DELETE_TASK = gql`
  mutation deleteTask($id: ID!) {
    deleteTask(id: $id)
  }
`

export const MUTATION_DELETE_TASKS = gql`
  mutation deleteTasks($ids: [ID!]!) {
    deleteTasks(ids: $ids)
  }
`

export const MUTATION_DELETE_ALL_TASKS_OF_ZONE = gql`
  mutation deleteAllTasksOfZone($input: DeleteAllTasksOfZoneInput!) {
    deleteAllTasksOfZone(input: $input)
  }
`

export const MUTATION_UPDATE_START_DATE_OF_ZONE = gql`
  mutation updateStartDateOfZone($input: UpdateStartDateOfZoneInput!) {
    updateStartDateOfZone(input: $input)
  }
`

export const MUTATION_MOVE_ALL_TASK_FROM_ZONE_TO_ANOTHER = gql`
  mutation moveAllTasksFromZoneToAnother($input: MoveAllTasksFromZoneInput!) {
    moveAllTasksFromZoneToAnother(input: $input)
  }
`

export const MUTATION_DELETE_ALL_TASKS_OF_COMPANY = gql`
  mutation deleteAllTasksOfCompany($input: DeleteAllTasksOfCompanyInput!) {
    deleteAllTasksOfCompany(input: $input)
  }
`

export const MUTATION_UPDATE_START_DATE_OF_COMPANY = gql`
  mutation updateStartDateOfCompany($input: UpdateStartDateOfCompanyInput!) {
    updateStartDateOfCompany(input: $input)
  }
`

export const MUTATION_MOVE_ALL_TASK_FROM_COMPANY_TO_ANOTHER = gql`
  mutation moveAllTasksFromCompanyToAnother($input: MoveAllTasksFromCompanyInput!) {
    moveAllTasksFromCompanyToAnother(input: $input)
  }
`

export const MUTATION_DELETE_ALL_TASKS_OF_TRADE = gql`
  mutation deleteAllTasksOfTrade($input: DeleteAllTasksOfTradeInput!) {
    deleteAllTasksOfTrade(input: $input)
  }
`

export const MUTATION_UPDATE_START_DATE_OF_TRADE = gql`
  mutation updateStartDateOfTrade($input: UpdateStartDateOfTradeInput!) {
    updateStartDateOfTrade(input: $input)
  }
`

export const MUTATION_MOVE_ALL_TASK_FROM_TRADE_TO_ANOTHER = gql`
  mutation moveAllTasksFromTradeToAnother($input: MoveAllTasksFromTradeInput!) {
    moveAllTasksFromTradeToAnother(input: $input)
  }
`

export const MUTATION_UPDATE_TASK_POSITIONS = gql`
  mutation updateTaskPositions($input: TaskPositionsUpdateInput!) {
    updateTaskPositions(input: $input) {
      ...TaskFragment
    }
  }
  ${TaskFragment}
`

export const MUTATION_UPDATE_TASK_COLOR = gql`
  mutation updateTaskColor($input: TaskColorUpdateInput!) {
    updateTaskColor(input: $input)
  }
`
